/**
 * Takes a string representing a name and turns it into initials.
 * @param name
 * @return {string}
 */
 export function getInitials(name){
  return name.split(" ").map((n)=>n[0]).join("").toUpperCase();
}